import { take, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { of } from 'rxjs';
import { BenefitsService } from '../services/benefits.service';

@Injectable({
  providedIn: 'root'
})
export class ResolveBenefitsService implements Resolve<any> {

  
  constructor(
    private benefitsService: BenefitsService) { }

  resolve(): Observable<any> {
     return this.benefitsService.findAll().pipe(
       take(1),
       mergeMap(benefits => {
        return of(benefits['object']);
       })
     );
  }

}
